<template>
  <section class="mt-4 px-5 overflow-x-hidden">
    <template>
      <p class="text-xs font-light pb-1 border-b">RECIPIENT BANK DETAILS</p>
      <ul class="font-light text-xs lg:text-sm">
        <li class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6">
          <span>Country</span>
          <span
            >{{
              transactionDetails.transferInstruction.bankDetails.country || '--'
            }}
          </span>
        </li>
        <li class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6">
          <span>Bank Name</span>
          <span>
            {{
              transactionDetails.transferInstruction.bankDetails.bankName ||
              '--'
            }}</span
          >
        </li>
        <li class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6">
          <span>Account No</span>
          <span
            >{{
              transactionDetails.transferInstruction.bankDetails
                .accountNumber || '--'
            }}
            <span
              class="cursor-pointer mb-1 ml-2"
              v-clipboard:copy="
                'transactionDetails.transferInstruction.bankDetails.accountNumber'
              "
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <copy-icon />
            </span>
          </span>
        </li>
        <li class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6">
          <span>Account Name</span>
          <span
            >{{
              transactionDetails.transferInstruction.bankDetails.accountName ||
              '--'
            }}
          </span>
        </li>
        <li
          v-if="!isCurrencyNGN"
          class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6"
        >
          <span>Bank Branch</span>
          <span
            >{{
              transactionDetails.transferInstruction.bankDetails.bankBranch ||
              '--'
            }}
          </span>
        </li>
        <li
          v-if="!isCurrencyNGN"
          class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6"
        >
          <span>Swift Code</span>
          <span
            >{{
              transactionDetails.transferInstruction.bankDetails.swiftCode ||
              '--'
            }}
          </span>
        </li>
        <li
          v-if="!isCurrencyNGN"
          class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6"
        >
          <span>Routing Number</span>
          <span
            >{{
              transactionDetails.transferInstruction.bankDetails
                .routingNumber || '--'
            }}
          </span>
        </li>
      </ul>
    </template>
    <template>
      <p class="text-xs font-light pb-1 border-b mt-10">RECIPIENT DETAILS</p>
      <ul class="font-light text-xs lg:text-sm">
        <li class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6">
          <span>Country</span>
          <span
            >{{
              transactionDetails.transferInstruction.personalDetails.country ||
              '--'
            }}
          </span>
        </li>
        <li class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6">
          <span>City</span>
          <span
            >{{
              transactionDetails.transferInstruction.personalDetails.city ||
              '--'
            }}
          </span>
        </li>
        <li
          class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6 overflow-x-scroll"
        >
          <span>Address</span>
          <span style="word-break: normal"
            >{{
              transactionDetails.transferInstruction.personalDetails.address ||
              '--'
            }}
          </span>
        </li>
        <li class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6">
          <span>Name</span>
          <span
            >{{
              transactionDetails.transferInstruction.personalDetails.name ||
              '--'
            }}
          </span>
        </li>
        <li class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6">
          <span>District</span>
          <span
            >{{
              transactionDetails.transferInstruction.personalDetails.district ||
              '--'
            }}
          </span>
        </li>
      </ul>
    </template>
  </section>
</template>

<script>
import { MaskWalletAddressTwo } from '@/utils/helpers.js'
export default {
  props: {
    transactionDetails: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  components: {
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue')
  },
  computed: {
    isCurrencyNGN () {
      return this.transactionDetails.currency === this.$CURRENCY.NGN
    },
    mobileMoneyDetails () {
      return [
        {
          label: 'Account Name',
          value:
            this.transactionInfo?.transferDestination?.bankDetails?.accountName
        },
        {
          label: 'Phone Number',
          value:
            this.transactionInfo?.transferDestination?.bankDetails
              ?.accountNumber
        },
        {
          label: 'Mobile Money Provider',
          value:
            this.transactionInfo?.transferDestination?.bankDetails?.bankName
        },
        {
          label: 'Provider Code',
          value:
            this.transactionInfo?.transferDestination?.bankDetails?.bankCode
        }
      ]
    }
  },
  methods: {
    maskID (val) {
      return MaskWalletAddressTwo(val)
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    parseNetworkName (name) {
      return ParseNetworkName(name)
    }
  }
}
</script>
